import { io } from 'socket.io-client';

class SocketService {
  constructor() {
    this.socket = null;
    this.isConnected = false;
    this.adminId = null;
  }

  connect(adminId, token) {
    if (this.socket && this.isConnected) return;

    this.socket = io(process.env.REACT_APP_BACKEND_URL || 'https://coolprofessors-backend-production.up.railway.app', {
      auth: {
        token: token
      },
      transports: ['websocket', 'polling']
    });

    this.socket.on('connect', () => {
      console.log('🔌 Connected to WebSocket server');
      this.isConnected = true;
      
      // Authenticate as admin
      this.socket.emit('admin-authenticate', {
        adminId: adminId,
        role: 'admin'
      });
    });

    this.socket.on('admin-authenticated', (data) => {
      console.log('👑 Admin authenticated with WebSocket');
    });

    this.socket.on('admin-notification', (data) => {
      console.log('📢 Admin notification received:', data);
      // Dispatch to your notification context or Redux store
      if (window.dispatchAdminNotification) {
        window.dispatchAdminNotification(data);
      }
    });

    this.socket.on('tutor-approved', (data) => {
      console.log('✅ Tutor approved notification:', data);
      // Refresh tutor applications list
      if (window.refreshTutorApplications) {
        window.refreshTutorApplications();
      }
    });

    this.socket.on('tutor-rejected', (data) => {
      console.log('❌ Tutor rejected notification:', data);
      // Refresh tutor applications list
      if (window.refreshTutorApplications) {
        window.refreshTutorApplications();
      }
    });

    this.socket.on('disconnect', () => {
      console.log('🔌 Disconnected from WebSocket server');
      this.isConnected = false;
    });

    this.socket.on('error', (error) => {
      console.error('WebSocket error:', error);
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
      this.isConnected = false;
    }
  }

  // Get socket instance
  getSocket() {
    return this.socket;
  }

  // Check connection status
  isConnected() {
    return this.isConnected;
  }
}

export default new SocketService();